module.exports = __webpack_public_path__ + "static/andrew-harmening.917e3002.webp";